import { RemoteGetSuspectedStudentsRanking } from 'data/usecases';
import { GetSuspectedStudentsRankingUseCaseInterface } from 'domain/usecases';
import { makeApiUrlSuspectedStudentsRanking } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSuspectedStudentsRanking =
  (): GetSuspectedStudentsRankingUseCaseInterface =>
    new RemoteGetSuspectedStudentsRanking(
      makeApiUrlSuspectedStudentsRanking(),
      makeAxiosHttpClient(),
    );
